<template>
  <!-- 移除嵌套的 PerfectScrollbar，使用布局级别的滚动 -->
  <div class="about-us-page-content flex flex-col items-center max-ml:overflow-x-hidden max-ml:max-w-100vw">
    <div class="min-h-screen bg-[#f9fbff]">
      <!-- Hero Banner -->
      <section class="relative h-172.5 lg:h-172.5 bg-cover bg-center overflow-hidden max-ml:hidden">
        <div class="absolute inset-0">
          <Pic class="w-full h-full max-ml:object-cover max-ml:object-center max-ml:h-10rem"
            src="/images/pages/about-us/banner.webp" alt="" />
        </div>
        <PageContentCenter class="max-w-480 mx-auto h-full flex items-center relative max-ml:h-10rem">
          <div class="max-w-162">
            <h1 v-fade-up ref="heroTitle"
              class="text-10 sm:text-12 lg:text-14 font-semibold text-[#272E3B] leading-normal mb-4 sm:mb-8 opacity-0">
              关于我们
            </h1>
            <p v-fade-up ref="heroDesc" class="text-4 sm:text-5 lg:text-5 text-[#616671] leading-4 max-w-106 opacity-0">
              <!-- 修复 Hydration mismatch: 将打字动画组件包裹在 ClientOnly 中 -->
              <ClientOnly>
                <AnimateTextType :text="['和贵科技是一家集技术研发、产品运营的综合性软件开发及运营公司🚀', '提供企业数字化全链路方案🚀']"
                  :textColors="['#616671', '#616671']" :typingSpeed="75" :pauseDuration="1500" :showCursor="true"
                  cursorCharacter="▋" :loop="true" />
                <template #fallback>
                  <span class="text-[#616671]">和贵科技是一家集技术研发、产品运营的综合性软件开发及运营公司</span>
                </template>
              </ClientOnly>
            </p>
          </div>
        </PageContentCenter>
      </section>

      <section class="hidden max-ml:block">
        <Pic class="w-full" src="/images/mobile/about-us/banner.png"></Pic>
      </section>

      <!-- 标题 导航 -->
      <!-- <section class="sticky top-[4.75rem] z-2 max-lg:hidden!" aria-labelledby="section2-title"> -->
      <section class="z-2 max-ml:hidden" aria-labelledby="section2-title">
        <nav class="bg-white">
          <PageContentCenter>
            <ul class="flex justify-between text-center">
              <li class="flex-1 cursor-pointer about-up-page-section2-nav-li"
                :class="{ 'selected': activeSection === navs.id }" v-for="navs in titleNav" :key="navs.id">
                <a class="inline-block h-full w-full leading-[4.6875rem]" href="#"
                  @click.prevent="scrollToSection(navs.id)">
                  {{ navs.title }}
                </a>
              </li>
            </ul>
          </PageContentCenter>
        </nav>
      </section>

      <!-- 公司介绍 -->
      <section :id="titleNav[0].id"
        class="page-about-us-hegui relative py-16 sm:py-24 lg:py-20 max-ml:bg-white max-ml:h-auto!">
        <PageContentCenter
          class="max-w-480 mx-auto  relative mb-[1.5rem] text-center  max-ml:px-1rem max-lg:max-w-100vw">
          <h2 v-fade-up ref="eventsTitle"
            class="text-10 sm:text-12 lg:text-7.5 font-400 text-[#272E3B] leading-normal  max-ml:text-2rem  max-ml:mb-0!">
            关于和贵
          </h2>
          <p v-fade-up
            class="text-4 sm:text-5 lg:text-5 text-[#8F8F8F] ml:my-7 mt-6rem max-ml:my-1rem max-ml:mt-0.4rem">
            铭记每一座征程丰碑，照亮未来远大新程
          </p>
          <div
            class="w-[90rem] h-334.5 bg-gradient-to-b from-[rgba(255,255,255,0.9)] to-[rgba(255,255,255,0.6)] max-ml:bg-white max-lg:max-w-100vw max-ml:w-100% max-ml:h-auto!">
            <Pic src="/images/pages/about-us/image 131@2x.png" class="" />
            <div class="p-12.5 max-ml:p-0rem">
              <div class="flex justify-between mb-16 ">
                <div class="w-77.5 max-ml:hidden">
                  <Pic class="w-51 mb-5" src="/images/logo.svg" alt="" />
                  <h3 class="text-[#272E3B] text-5 text-left">湖南和贵网络科技有限公司</h3>
                </div>
                <article class="text-[#616671] text-[15px] w-[900px] leading-7 text-left mt-1rem">
                  <p class="indent-8">
                    和贵科技致力于成为企业数字化转型中最值得信赖的合作伙伴。目前，公司已构建湖南与广东双总部运营体系。以技术创新和深度服务赢得如口味王等多个头部品牌的深度信赖，实现数字化跨越。TOB渠道玩法、企业数字化生态布局更是行业领先。
                  </p>
                  <p class="indent-8">
                    一物一码+会员体系：赋能企业构建商品和会员的数字化。打通品牌商→经销商→零售店→消费者的全链路数据闭环，结合“积分+优惠券+等级权益”等各种组合玩法实现多家企业扫码量日峰值均已达行业首位、数亿用户在私域的沉淀、复购率提升35%，已助力多家企业成为行业数字化标杆。
                  </p>
                </article>
              </div>

              <ul v-fade-up
                class="flex ml:justify-end ml:text-left mb-26 max-ml:mb-10 max-ml:flex-row max-ml:flex-wrap max-ml:text-center! max-ml:justify-around">
                <li class="mr-[220px] max-ml:mr-0  max-ml:w-33% max-ml:mb-1rem  max-ml:text-1rem">
                  <span class="text-[#9F9F9F] text-4.5 max-ml:text-0.8rem">员工数量</span>
                  <div class="text-[#272E3B] text-12 font-semibold max-ml:text-2rem" ref="employeeCount">0<span
                      class="text-8 font-black">+</span> </div>
                </li>
                <li class="mr-[220px] max-ml:mr-0  max-ml:w-33% max-ml:mb-1rem  max-ml:text-1rem">
                  <span class="text-[#9F9F9F] text-4.5 max-ml:text-0.8rem">成果数量</span>
                  <div class="text-[#272E3B] text-12 font-semibold max-ml:text-2rem" ref="achievementCount">0<span
                      class="text-8 font-black">+</span> </div>
                </li>
                <li class="mr-[110px] max-ml:mr-0  max-ml:w-33% max-ml:mb-1rem  max-ml:text-1rem">
                  <span class="text-[#9F9F9F] text-4.5 max-ml:text-0.8rem">合作伙伴</span>
                  <div class="text-[#272E3B] text-12 font-semibold max-ml:text-2rem" ref="partnerCount">0<span
                      class="text-8 font-black">+</span> </div>
                </li>
              </ul>

              <ul v-fade-up :id="titleNav[1].id" class="flex bg-[#fff] max-ml:hidden">
                <li class="flex flex-col items-center ml:flex-1 my-12.5 ">
                  <Pic class='w-5.63rem' src="/images/pages/about-us/3 1@2x.png" alt="" />
                  <h6 class='text-5 text-[#222222] font-semibold mt-7.5 mb-4'>企业使命</h6>
                  <p class="text-[#8F8F8F] text-4 max-ml:px-1rem">
                    引领客户数字化转型，助力企业成就行业典范
                  </p>
                </li>
                <li class="flex flex-col items-center ml:flex-1 my-12.5  ">
                  <Pic class='w-5.63rem' src="/images/pages/about-us/6 662@2x.png" alt="" />
                  <h6 class='text-5 text-[#222222] font-semibold mt-7.5 mb-4'>企业宗旨</h6>
                  <p class="text-[#8F8F8F] text-4 max-ml:px-1rem">
                    致力于成为数字智能时代最值得信赖的合作伙伴
                  </p>
                </li>
                <li class="flex flex-col items-center ml:flex-1 my-12.5  ">
                  <Pic class='w-5.63rem' src="/images/pages/about-us/1 5999@2x.png" alt="" />
                  <h6 class='text-5 text-[#222222] font-semibold mt-7.5 mb-4'>企业理念</h6>
                  <p class="text-[#8F8F8F] text-4 max-ml:px-1rem">
                    诚信立足 创新致远
                  </p>
                </li>
              </ul>

              <ul v-fade-up class="text-left flex justify-between bg-[#fff] ml:hidden max-ml:flex">
                <li
                  class="flex flex-col p-0.75rem rounded-0.5rem mr-0.7rem  bg-gradient-to-br from-[#F0FCFE] to-[#EEF8FD]  items-start w-9rem ">
                  <Pic class='w-5.63rem' src="/images/pages/about-us/3 1@2x.png" alt="" />
                  <h6 class='text-5 text-[#2F718D] font-semibold my-0.5rem '>企业使命</h6>
                  <p class="text-[#125FB7] text-0.7rem ">
                    引领客户数字化转型
                  </p>
                  <p class="text-[#125FB7] text-0.7rem ">
                    助力企业成就行业典范
                  </p>
                </li>
                <div class="w-10rem flex flex-col flex-1 justify-between">
                  <li
                    class="flex px-0.75rem py-0.9rem rounded-0.5rem  items-center bg-gradient-to-br from-[#F0FCFE] to-[#EEF8FD]  ">
                    <Pic class='w-3rem mr-0.5rem' src="/images/mobile/about-us/6 662 (1).png" alt="" />
                    <div>
                      <h6 class='text-5 text-[#2F718D] font-semibold  mb-0.5rem mr-0.5rem'>企业宗旨</h6>
                      <p class="text-[#125FB7] text-0.7rem ">
                        致力成为数字智能时代
                      </p>
                      <p class="text-[#125FB7] text-0.7rem ">
                        最值得信赖的合作伙伴
                      </p>
                    </div>
                  </li>
                  <li
                    class="flex  px-0.75rem py-0.9rem rounded-0.5rem items-center   bg-gradient-to-br from-[#F0FCFE] to-[#EEF8FD] ">
                    <Pic class='w-3rem mr-0.5rem' src="/images/mobile/about-us/6 662.png" alt="" />
                    <div>
                      <h6 class='text-4 text-[#2F718D] font-semibold mb-0.5rem '>企业理念</h6>
                      <p class="text-[#125FB7] text-0.7rem ">
                        诚信立足
                      </p>
                      <p class="text-[#125FB7] text-0.7rem ">
                        创新致远
                      </p>
                    </div>
                  </li>
                </div>
              </ul>

            </div>
          </div>
        </PageContentCenter>
      </section>

      <!-- 企业发展大事记 -->
      <section :id="titleNav[2].id" class="py-16 sm:py-24 py-20 max-ml:hidden">
        <PageContentCenter v-fade-up class="max-w-480 mx-auto text-center   relative mb-[1.5rem]">
          <h2 ref="eventsTitle"
            class="text-10 sm:text-12 text-7.5 font-400 text-[#272E3B] leading-normal ml:mb-4 max-ml:mb-0">
            企业发展大事记
          </h2>
          <p class="text-4 sm:text-5 text-5 text-[#616671] my-7">
            夯实前行基石，共绘发展新篇
          </p>
        </PageContentCenter>
        <div class="max-w-480 mx-auto relative flex justify-center h-188.25">

          <!-- 装饰性背景 -->
          <!-- <PageContentCenter
            class="absolute w-full h-full transform w-278 sm:w-400 lg:w-278 h-103 opacity-60 pointer-events-none">
            <Pic :src="bigEventsBack" alt="" />
          </PageContentCenter> -->

          <PageContentCenter class="absolute w-full">
            <Pic src="/images/pages/about-us/hghg-t- (1).png" alt="" />
          </PageContentCenter>
          <PageContentCenter>

          </PageContentCenter>
        </div>
      </section>
      <!-- 移动端 -->
      <section :id="titleNav[2].id" class="py-16 sm:py-24 py-20 ml:hidden">
        <PageContentCenter v-fade-up class="max-w-480 mx-auto text-center   relative mb-[1.5rem]">
          <h2 ref="eventsTitle" class="text-10 sm:text-12 text-7.5 font-400 text-[#272E3B] leading-normal mb-4 sm:mb-8">
            企业发展大事记
          </h2>
          <p class="text-4 sm:text-5 text-5 text-[#616671] my-7">
            夯实前行基石，共绘发展新篇
          </p>
        </PageContentCenter>
        <div class="h-18rem overflow-hidden">
          <div ref="scrollContainer" class="relative w-[100vw] overflow-x-scroll overflow-y-hidden h-30rem">
            <ul class="flex gap-x-4 px-4 py-2 h-24rem px-1rem w-max">
              <li class="flex-shrink-0 w-[40vw] bg-white overflow-hidden rounded h-17rem shadow py-2rem px-1rem"
                v-for="item in timeline" :key="item.year">
                <h5 class="text-primary text-1.3rem font-bold">{{ item.year }}</h5>
                <p v-for="titleItem in item.titles" class="text-1.1rem my-0.5rem">{{ titleItem }}</p>
                <p class="text-sm text-wrap text-gray-500">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- 和贵科技服务体系 - 企业数字化全链路方案 -->
      <section :id="titleNav[3].id" class="py-30 bg-[#213787] page-section-solution max-ml:hidden">
        <PageContentCenter class="max-w-480 mx-auto mb-26 max-lg:max-w-100vw">
          <div v-fade-up class="flex flex-col sm:flex-row justify-center mb-6rem">
            <div v-fade-up class="mb-4 sm:mb-0 lg:text-center">
              <h2 class=" text-8 sm:text-10 lg:text-7.5  text-[#fff] mb-3">
                和贵科技服务体系 - 企业数字化全链路方案
              </h2>
              <p class="w-[856px] text-4 sm:text-4 lg:text-4  text-[rgba(255,255,255,0.7)]">
                和贵科技以企业全流程业务链路梳理为核心，通过精准分层与服务环节解构，强化节点协同效能，实现从初始需求捕捉至最终价值交付的全周期数字化赋能与一体化业务支撑！
              </p>
            </div>
          </div>

          <v-sheet class="d-flex bg-transparent about-us-solution-develop-history" elevation="4">
            <v-tabs v-model="tab" class="bg-[#DBE8FF] py-[60px] rounded-3" direction="vertical">
              <v-tab v-for="item in sheetTabsList" :key="item.id" :value="item.id"
                class="h-22.5! w-77 text-[#272E3B] text-4.5! mb-3 flex">
                <Pic class="w-2.63rem h-2.63rem m-r-0.5rem" :src="item.icon"></Pic>
                <span>{{ item.title }}</span>
              </v-tab>
            </v-tabs>

            <v-divider vertical class="px-4"></v-divider>

            <v-tabs-window v-model="tab"
              class="rounded-3 w-[1116px] h-[528px] p-[46px] pl-[52px] page-section-solution-windows">
              <v-tabs-window-item v-for="item in sheetTabsList" :key="item.id" :value="item.id">
                <h6 class="text-[30px] mb-[68px] font-600">{{ item.title }}</h6>
                <div class="bg-[#fff] rounded-3 px-[28px] py-[32px] w-[1012px] h-[305px] relative">
                  <Pic v-fade-up useOriginUrl class="w-108 h-96 absolute top-[-10rem] right-0" :src="item.asideImage"
                    alt="" />
                  <p v-for="description in item.descriptions"
                    class="text-[#616671] text-[14px] pl-6 relative mb-6 w-80% page-section-solution-details"
                    v-html="description">
                  </p>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-sheet>
        </PageContentCenter>
      </section>

      <section class="page-section-solution-mobile ml:hidden">
        <PageContentCenter class="max-ml:px-1rem">
          <div v-fade-up class="flex flex-col justify-center text-center mb-1rem">
            <div v-fade-up class="mb-4  pt-3rem">
              <h2 class=" text-8 sm:text-10 lg:text-7.5 font-400 text-[#fff] mb-3">
                和贵科技服务体系
                <br />
                企业数字化全链路方案
              </h2>
              <p class="text-1rem  text-[rgba(255,255,255,0.7)]">
                和贵科技以企业全流程业务链路梳理为核心，通过精准分层与服务环节解构，强化节点协同效能，实现从初始需求捕捉至最终价值交付的全周期数字化赋能与一体化业务支撑！
              </p>
            </div>
          </div>

          <v-carousel class="page-section-solution-mobile-carousel" interval="3000" cycle hide-delimiters
            :show-arrows="false">
            <v-carousel-item v-for="item in sheetTabsList">
              <div
                class="bg-[#fff] rounded-3 px-[28px] py-[32px] h-23.5rem  relative page-section-solution-mobile-card">
                <h6 class="text-[30px] mb-[68px] font-600">{{ item.title }}</h6>
                <Pic v-fade-up useOriginUrl class=" w-10rem absolute bottom-[3rem] right-0" :src="item.asideImage"
                  alt="" />
                <p v-for="description in item.descriptions"
                  class="text-[#616671] text-1rem pl-6 relative mb-6 w-100 page-section-solution-details"
                  v-html="description">
                </p>
              </div>
            </v-carousel-item>
          </v-carousel>
        </PageContentCenter>
      </section>

      <!-- 企业科技成果 -->
      <section :id="titleNav[4].id" class="enterprise-technology pb-13.5rem pt-6.56rem bg-[#f8faff] max-ml:pb-3rem">
        <PageContentCenter class="max-w-480 mx-auto  ">
          <div v-fade-up class="flex flex-col mb-12rem relative">
            <div class="mb-4 sm:mb-0 text-center absolute left-1/2 translate-x--1/2">
              <h2 class="text-center text-8 text-7.5  text-[#272E3B] mb-1rem">
                企业科技成果
              </h2>
              <p class="text-4 sm:text-4 lg:text-4 text-[#8F8F8F] max-ml:w-100vw max-ml:px-2rem">
                和贵科技专注于为行业提供以数据驱动的研发、运营、创新一体化解决方案
              </p>
            </div>
            <div class="text-center absolute left-[1250px] max-ml:relative max-ml:top-8rem max-ml:left-0">
              <div ref="counterElement" class=" text-10 sm:text-12 lg:text-12.5 font-semibold color-primary">0+</div>
              <p class="text-3.5 sm:text-4.25 text-[#616671] mt-1">目前企业获拥软著成果</p>
            </div>
          </div>

          <!-- 产品网格 -->
          <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-4.5">
            <div v-for="(product, index) in products" :key="index"
              class="bg-white  rounded-2 p-24 flex flex-col items-center gap-5
                  transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_.375rem_1.125rem_rgba(31,35,41,0.08)]">
              <div :ref="(el) => setImageRef(el, index)" class="w-12 h-12 rounded-2 flex items-center justify-center"
                :data-index="index">
                <Pic :src="product.icon" class="w-12 h-12 transition-transform duration-300" />
              </div>

              <!-- 修复 Hydration mismatch: 将动画组件包裹在 ClientOnly 中 -->
              <ClientOnly>
                <AnimateShinyText class-name="text-3.5 text-[#1f2329] text-center leading-5" :text="product.name" />
                <template #fallback>
                  <span class="text-3.5 text-[#1f2329] text-center leading-5">{{ product.name }}</span>
                </template>
              </ClientOnly>
            </div>
          </div>
        </PageContentCenter>
      </section>

      <!-- 企业荣誉 -->
      <section :id="titleNav[5].id" class="honor-card-content py-20 text-center">
        <PageContentCenter class="max-w-480 mx-auto max-ml:px-1rem">
          <div v-fade-up class="flex flex-col sm:flex-row justify-center mb-8 sm:mb-12 lg:mb-8">
            <div class="mb-4 sm:mb-0">
              <h2 class="text-8 sm:text-10 lg:text-7.5 font-400 text-[#272E3B] mb-3">
                企业荣誉
              </h2>
              <p class="text-4 sm:text-5 lg:text-5 text-[#8F8F8F]">
                诚信立足，创新致远
              </p>
            </div>
          </div>

          <!-- 荣誉证书 -->

          <div class="flex flex-wrap justify-between max-ml:justify-around max-ml:hidden">
            <v-sheet v-for="(honor, index) in honors" :key="index" :class="{
              'opacity-0': honor.isPlaceholder
            }" class="honor-card flex flex-col items-center p-1 box-border w-21 h-24.69 mb-14.8 text-center relative">
              <div class="honor-card-image-box w-19.16rem h-18.05rem absolute left-1rem top-1rem">
                <Pic class="honor-card-image absolute" :src="honor.img" alt="" />
              </div>
              <p class="text-3.5 text-[#616671] font-medium absolute bottom-2rem left-1/2 -translate-x-1/2">{{
                honor.title }}
              </p>
            </v-sheet>
          </div>

          <div class="flex flex-wrap justify-between max-ml:justify-around ml:hidden">
            <v-sheet v-for="(honor, index) in honors" :key="index" :class="{
              'opacity-0': honor.isPlaceholder
            }"
              class="honor-card-mobile flex flex-col items-center p-0.5rem box-border  mb-0.8rem text-center relative max-ml:w-30%! ">
              <div class="honor-card-image-box-mobile  p-1rem max-ml:max-w-100% ">
                <Pic class="honor-card-image-mobile" :src="honor.mobileImg" alt="" />
              </div>
              <p class="mt-0.5rem text-0.5rem text-[#616671] font-medium ">{{
                honor.title }}
              </p>
            </v-sheet>
          </div>
        </PageContentCenter>
      </section>
      <SiteMap />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, inject, shallowReactive } from 'vue'
import { useSeoMeta } from 'nuxt/app'
import { useScrollAnimation } from '~/@core/composable/useScrollAnimation'
import { useCounterAnimation } from '~/@core/composable/useCounterAnimation'
import { useAppScrollBus } from '@base/@core/composable/useAppScroll'
import bigEventsBack from '@base/images/about-us/big-events-back.png'
// const { isMobile } = useDevice()
const { onScroll } = useAppScrollBus()
const activeSection = ref('company-intro')
let hashDomMap: { id: string; top: number; height: number }[] = []
const pageScrollbar = inject('pageScrollbar')
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
onMounted(() => {
  // 初始化收集 section 位置信息
  titleNav.forEach((item) => {
    const ele = document.querySelector<HTMLElement>(`#${item.id}`)
    if (ele) {
      hashDomMap.push({
        id: item.id,
        top: ele.offsetTop,
        height: ele.offsetHeight
      })
    }
  })
})

const scrollContainer = ref<HTMLElement | null>(null)

onMounted(() => {
  const el = scrollContainer.value
  if (!el) return

  // 初始位置
  el.scrollLeft = 16

  let isBouncing = false

  const onScroll = () => {
    if (isBouncing) return

    const maxScroll = el.scrollWidth - el.clientWidth

    // 到最左边
    if (el.scrollLeft <= 0) {
      isBouncing = true
      el.scrollTo({ left: 16, behavior: 'smooth' })
      setTimeout(() => (isBouncing = false), 300)
    }

    // 到最右边
    if (el.scrollLeft >= maxScroll) {
      isBouncing = true
      el.scrollTo({ left: maxScroll - 16, behavior: 'smooth' })
      setTimeout(() => (isBouncing = false), 300)
    }
  }

  el.addEventListener('scroll', onScroll)
  onUnmounted(() => el.removeEventListener('scroll', onScroll))
})


let off: (() => void) | undefined
onMounted(() => {
  off = onScroll(({ scrollTop }) => {
    // 当前视口中线位置（加上容器滚动偏移量）
    const viewportMiddle = scrollTop + window.innerHeight / 2

    // 找出当前处于视口中的 section
    for (let i = 0; i < hashDomMap.length; i++) {
      const s = hashDomMap[i]
      if (viewportMiddle >= s.top && viewportMiddle < s.top + s.height) {
        if (activeSection.value !== s.id) {
          activeSection.value = s.id
        }
        break
      }
    }
  })
})

onUnmounted(() => {
  off?.()
})

function updateHashDomMap() {
  hashDomMap = titleNav.map(item => {
    const ele = document.querySelector<HTMLElement>(`#${item.id}`)
    return ele
      ? { id: item.id, top: ele.offsetTop, height: ele.offsetHeight }
      : null
  }).filter(Boolean) as { id: string; top: number; height: number }[]
}

onMounted(() => {
  updateHashDomMap()
  window.addEventListener('resize', updateHashDomMap)
})
onUnmounted(() => {
  window.removeEventListener('resize', updateHashDomMap)
})


const tab = ref('one') // 添加tab响应式变量

const timeline = [
  {
    year: '2019年',
    left: '3rem', // 对应 left-12
    top: '29rem', // 对应 top-116
    titles: ['和贵成立'],
    desc: '和贵科技梦想启航,彼时企业作为初创团队仅由3名员工组成。',
  },
  {
    year: '2020年',
    left: '13rem',
    top: '8rem',
    titles: ['飞马上线'],
    desc: '技术团队研发的飞马外勤项目 正式上线',
  },
  {
    year: '2021年',
    left: '23rem',
    top: '27.5rem',
    titles: ['快乐达上线'],
    desc: '同年飞马外勤开通机构430+ 账户数量达9000+',
  },
  {
    year: '2022年',
    left: '32rem',
    top: '6.6rem',
    titles: ['会员积分商城上线'],
    desc: '该年度商城会员数量达400w+ 销售额500w+',
  },
  {
    year: '2023年',
    left: '42rem',
    top: '24.5rem',
    titles: ['线上商城 和贵云商上线'],
    desc: '该年度飞马外勤累计开通机构1000+ 账户数量25000+',
  },
  {
    year: '2024年',
    left: '52rem',
    top: '4.5rem',
    titles: ['新零售平台 即时鸟上线'],
    desc: '员工数量增至180+ 积分商城会员达到5700w+ 累计销售额3.6亿+',
  },
  {
    year: '2025年',
    left: '62rem',
    top: '23.5rem',
    titles: [
      '商家会员中心',
      '品牌供应链系统',
      '即时榔',
      '即得电',
      '一物一码',
      // '数据平台上线',
    ],
  },
];

const titleNav = shallowReactive([
  {
    title: '公司介绍',
    id: 'company-intro',
    alias: 'company-intro',
  },
  {
    title: '企业文化',
    id: 'company-culture',
    alias: 'company-culture',
  },
  {
    title: '发展历程',
    id: 'development-history',
    alias: 'development-history',
  },
  {
    title: '服务体系',
    id: 'service-system',
    alias: 'service-system',
  },
  {
    title: '企业成果',
    id: 'company-achievements',
    alias: 'company-achievements',
  },
  {
    title: '企业荣誉',
    id: 'company-honors',
    alias: 'company-honors',
  },
])!


onMounted(async () => {
  await nextTick()
  const hash = window.location.hash
  if (hash) {
    const target = document.querySelector(hash)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
})

function scrollToSection(id: string) {
  // 首先尝试通过 PageScrollbar 组件滚动

  const el = document.getElementById(id)
  if (el) {
    // 使用 PageScrollbar 组件的 scrollTo 方法
    const offsetTop = el.offsetTop
    pageScrollbar?.value.scrollTo(0, offsetTop - 100)
    activeSection.value = id
    history.replaceState(null, '', `#${id}`)
    return
  }
}
const pageLayoutStore = usePageLayoutStore()

// 修复：使用数组来存储 refs
const imageRefs = ref<HTMLDivElement[]>([])

// 修复：创建一个函数来设置 ref
const setImageRef = (el: Element | ComponentPublicInstance | null, index: number) => {
  if (el && el instanceof HTMLDivElement) {
    imageRefs.value[index] = el
  }
}

onMounted(() => {
  pageLayoutStore.setPageContentStyle({
    overflow: 'hidden'
  })

  // 修复：使用 nextTick 确保 DOM 已更新，并为每个元素创建独立的 ref
  nextTick(() => {
    imageRefs.value.forEach((element, index) => {
      if (element) {
        // 为每个元素添加延迟，实现依次触发动画的效果
        setTimeout(() => {
          const elRef = ref<HTMLElement | null>(element)
          useScrollAnimation(elRef, 'animate-fade-zoom', {
            threshold: 0.2,
            once: false,
          })
        }, index * 150)
      }
    })
  })
})

onUnmounted(() => {
  pageLayoutStore.setPageContentStyle({})
})


// Hero 区域的元素引用
const heroTitle = ref<HTMLElement | null>(null)
const heroDesc = ref<HTMLElement | null>(null)

// 数字滚动元素引用
const counterElement = ref<HTMLElement | null>(null)
const employeeCount = ref<HTMLElement | null>(null)
const achievementCount = ref<HTMLElement | null>(null)
const partnerCount = ref<HTMLElement | null>(null)

// 绑定滚动动画
useScrollAnimation(heroTitle, 'animate-slide-in-right', { threshold: 0.2, once: false })
useScrollAnimation(heroDesc, 'animate-fade-in', { threshold: 0.2, once: false })

// 绑定数字滚动动画（1.5秒内滚动到30）
useCounterAnimation(counterElement, 30, { duration: 1500, threshold: 0.1 })
useCounterAnimation(employeeCount, 200, { duration: 1500, threshold: 0.1 })
useCounterAnimation(achievementCount, 30, { duration: 1000, threshold: 0.05 })
useCounterAnimation(partnerCount, 1700, { duration: 1500, threshold: 0.1 })

// SVG 路径动画 - 客户端渲染
// onMounted(() => {
//   if (process.client) {
//     // 使用 nextTick 确保 DOM 完全渲染
//     nextTick(() => {
//       // 添加延迟确保 DOM 完全加载
//       setTimeout(() => {
//         const path = document.querySelector('#curve') as SVGPathElement
//         const dots = document.querySelectorAll('.dot') as NodeListOf<SVGCircleElement>

//         if (path && dots.length > 0) {
//           // 强制重新获取路径属性
//           const pathData = path.getAttribute('d')

//           const pathLength = path.getTotalLength()

//           // 为每个圆点创建动画,设置不同的起始偏移
//           dots.forEach((dot, index) => {
//             const animate = () => {
//               const startTime = performance.now()
//               const duration = 4000 // 4秒
//               // 根据圆点索引设置不同的起始偏移,使它们均匀分布
//               const offset = (index / dots.length) * pathLength

//               const update = (currentTime: number) => {
//                 const elapsed = currentTime - startTime
//                 const progress = (elapsed % duration) / duration
//                 const distance = (progress * pathLength + offset) % pathLength

//                 try {
//                   const point = path.getPointAtLength(distance)

//                   // 验证坐标值是否有效
//                   if (point && typeof point.x === 'number' && typeof point.y === 'number' &&
//                     !isNaN(point.x) && !isNaN(point.y) && isFinite(point.x) && isFinite(point.y)) {
//                     const xValue = String(Math.round(point.x * 100) / 100)
//                     const yValue = String(Math.round(point.y * 100) / 100)
//                     dot.setAttribute('cx', xValue)
//                     dot.setAttribute('cy', yValue)
//                   }
//                 } catch (error) {
//                   console.error('SVG 动画更新错误:', error)
//                 }

//                 requestAnimationFrame(update)
//               }

//               requestAnimationFrame(update)
//             }

//             animate()
//           })
//         }
//         else {
//           console.error('未找到 SVG 元素')
//         }
//       }, 200)
//     })
//   }
// })


// 设置页面元信息
useSeoMeta({
  title: '关于我们',
  description: '和贵科技是一家集技术研发、产品运营的综合性软件开发及运营公司',
})

// 页面可选配置
definePageMeta({
  layout: 'default',
})


// 产品数据 - 第一行
const products = [
  {
    name: '新零售SaaS营销系统',
    icon: '/images/pages/about-us/logo@2x.png',
    bgColor: '#1966f6',
  },
  {
    name: '飞马外勤管理系统',
    icon: '/images/pages/about-us/Group 427319479@2x.png',
    bgColor: '#f5f5f5',
  },
  {
    name: '即时榔小程序',
    icon: '/images/pages/about-us/Group 427321018@2x.png',
    bgColor: '#fae800',
  },
  {
    name: '即时鸟新零售SaaS系统',
    icon: '/images/pages/about-us/即时鸟logo@2x.png',
    bgColor: '#e43e3e',
  },
  {
    name: '和贵云商供应链中心系统',
    icon: '/images/pages/about-us/Group 427319270@2x.png',
    bgColor: '#c93332',
  },
  {
    name: '员工关怀管理系统',
    icon: '/images/pages/about-us/Group 427319658@2x.png',
    bgColor: '#4a90e2',
  },
  {
    name: '快乐达',
    icon: '/images/pages/about-us/Group 427319270@2x(1).png',
    bgColor: '#c93332',
  },
  {
    name: '门店收银系统',
    icon: '/images/pages/about-us/Group 427321018@2x(1).png',
    bgColor: '#fae800',
  },
  {
    name: '和成天下会员中心',
    icon: '/images/pages/about-us/logo@2x(1).png',
    bgColor: '#1966f6',
  },
  {
    name: '口味王商家会员中心',
    icon: '/images/pages/about-us/Group 427319658@2x(1).png',
    bgColor: '#4a90e2',
  },
  {
    name: '即得电小程序',
    icon: '/images/pages/about-us/Group 427319479@2x(1).png',
    bgColor: '#f5f5f5',
  },
  {
    name: '口味王会员中心',
    icon: '/images/pages/about-us/Group 427319658@2x(2).png',
    bgColor: '#e43e3e',
  },
]

const sheetTabsList = [
  {
    "id": "research",
    "title": "业务诊断与需求调研",
    "descriptions": [
      "深入企业业务场景",
      "全面梳理全链路需求",
      "精准定位企业在数字化转型方面的痛点",
      "提供针对性的业务优化建议与服务方向规划"
    ],
    "icon": "/images/pages/about-us/y2.png",
    "backImage": "",
    asideImage: "/images/pages/about-us/image 143@2x.png"
  },
  {
    "id": "custom",
    "title": "定制化解决方案设计",
    "descriptions": [
      "基于行业特性定制全流程数字化方案，如：<br />一物一码溯源搭建、DMS经销渠道管理功能规划等<br />确保方案与业务深度契合"
    ],
    "icon": "/images/pages/about-us/y1.png",
    "backImage": "",
    asideImage: "/images/pages/about-us/image 180 1@2x.png"
  },
  {
    "id": "develop",
    "title": "全链路开发与落地",
    "descriptions": [
      "完成从系统底层架构搭建到上层功能开发的全流程落地",
      "多系统数据打通与集成",
      "同时保障系统承载能力与数据安全合规"
    ],
    "icon": "/images/pages/about-us/y2.png",
    "backImage": "",
    asideImage: "/images/pages/about-us/image 139@2x.png"
  },
  {
    "id": "maintain",
    "title": "技术迭代与运维保障",
    "descriptions": [
      "常态化运维服务，包括：<br/>系统日常巡检、故障响应修复、数据安全与升级迭代",
      "避免因技术问题影响企业业务推进"
    ],
    "icon": "/images/pages/about-us/y3.png",
    "backImage": "",
    asideImage: "/images/pages/about-us/image 140@2x.png"
  },

]

// 荣誉数据
const honors = [
  {
    title: '电商协会证书',
    img: '/images/pages/about-us/zs/1.png',
    mobileImg: '/images-tiny/pages/about-us/zs/1.png'
  },
  {
    title: '高新技术企业证书',
    img: '/images/pages/about-us/zs/2.png',
    mobileImg: '/images-tiny/pages/about-us/zs/2.png'
  },
  {
    title: '软件企业证书',
    img: '/images/pages/about-us/zs/3.png',
    mobileImg: '/images-tiny/pages/about-us/zs/3.png'
  },
  {
    title: '质量管理体系认证证书',
    img: '/images/pages/about-us/zs/4.png',
    mobileImg: '/images-tiny/pages/about-us/zs/4.png'
  },
  {
    title: '信息安全管理体系认证证书',
    img: '/images/pages/about-us/zs/4.1.png',
    mobileImg: '/images-tiny/pages/about-us/zs/4.1.png'
  },
  {
    title: '飞马外勤',
    img: '/images/pages/about-us/zs/5.png',
    mobileImg: '/images-tiny/pages/about-us/zs/5.png'
  },
  {
    title: '海量轨迹存储处理系统',
    img: '/images/pages/about-us/zs/6.png',
    mobileImg: '/images-tiny/pages/about-us/zs/6.png'
  },
  {
    title: '和贵会员兑换中心小程序',
    img: '/images/pages/about-us/zs/7.png',
    mobileImg: '/images-tiny/pages/about-us/zs/7.png'
  },
  {
    title: '和贵云商-供应链中心系统',
    img: '/images/pages/about-us/zs/8.png',
    mobileImg: '/images-tiny/pages/about-us/zs/8.png'
  },

  {
    title: '和贵云商小程序',
    img: '/images/pages/about-us/zs/9.png',
    mobileImg: '/images-tiny/pages/about-us/zs/9.png'
  },

  {
    title: '和贵智收门店收银系统',
    img: '/images/pages/about-us/zs/10.png',
    mobileImg: '/images-tiny/pages/about-us/zs/10.png'
  },
  {
    title: '即时鸟商家版软件',
    img: '/images/pages/about-us/zs/11.png',
    mobileImg: '/images-tiny/pages/about-us/zs/11.png'
  },
  {
    title: '新零售SaaS-营销中心系统',
    img: '/images/pages/about-us/zs/12.png',
    mobileImg: '/images-tiny/pages/about-us/zs/12.png'
  },
  {
    isPlaceholder: true
  },
  {
    isPlaceholder: true
  },
]

</script>

<style lang="scss">
/* 移除 PerfectScrollbar 相关样式，使用默认滚动 */
@import "@base/@core/scss/template/libs/vuetify/variables";

.page-section-solution-mobile-carousel {
  .v-window__controls {
    display: none;
  }

  .v-window__container {
    height: 528px;
  }
}

/* global.css */
.page-section-solution-mobile {
  background-image: url("/images/mobile/about-us/callo.png");
  background-size: cover;
}

.cross-scale-enter-active,
.cross-scale-leave-active {
  transition: 0.5s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition-property: opacity, transform;
}

.cross-scale-leave-from,
.cross-scale-leave-to {
  position: absolute !important;
  top: 0;
  width: 100%;
}

.cross-scale-enter-from,
.cross-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

@media (prefers-reduced-motion: reduce) {

  .cross-scale-enter-from,
  .cross-scale-leave-to {
    transform: none;
  }
}

.about-us-solution-develop-history {
  background-color: red;

  .v-tab__slider {
    position: absolute;
    top: 19px;
    left: 0;
    width: 4px;
    height: 60%;
  }
}

.about-us-page-content {
  max-width: $page-max-width;
  padding-top: $table-header-height;

  .enterprise-technology {
    background-image: url("/images/pages/about-us/bj@2x (2).png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .about-up-page-section2-nav-li {
    // 未选中状态
    background-color: white;
    color: #000;
    transition: all 0.2s ease;

    // 未选中时的 hover 效果
    &:hover:not(.selected) {
      background-color: #e3f0fd; // 浅蓝色背景
      color: #000; // 文字保持黑色
    }

    // 选中状态
    &.selected {
      background-color: #1967f9 !important;
      color: #fff;

      // 选中时的 hover 效果
      &:hover {
        background-color: #4d8ef9; // 加亮的蓝色
        color: #fff;
      }
    }
  }

  .page-about-us-hegui {
    width: $page-max-width;
    height: 99rem;
    border-radius: 0;

    &::before {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("/images/pages/about-us/Mask group@2x(1).png");
      background-repeat: no-repeat;
      background-size: cover;
      content: "";
      opacity: 0.4;
    }

    @media (max-width: 1024px) {
      &::before {
        display: none;
      }
    }
  }
}

.page-section-solution {
  /* 移除空背景，避免无效声明 */
  background-image: url("/images/pages/about-us/Group 2147229647@2x.png");
  background-size: cover;

  &-windows {
    background-image: url("/images/pages/about-us/Mask group@2x(2).png");
    background-size: cover;
  }

  &-details {
    &::before {
      position: absolute;
      z-index: 0;
      top: 6px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: rgb(var(--v-theme-primary));
      content: "";
    }
  }
}

/* 提高选择器优先级，确保覆盖 Vuetify 与原有 utility 类 */
.page-section-solution .v-tab--selected,
.page-section-solution .v-tab--selected .v-btn__overlay {
  background: linear-gradient(90deg, #b8d1ff 0%, #dbe8ff 100%);
  font-weight: 600;
}

.about-us-page-content-inner {
  /* 移除绝对定位 */

  /* position: absolute; */

  /* z-index: 2; */

  /* overflow: auto; */
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0;
  margin: 0;

  /* inset: 0; */
}

@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateX(6.25rem) scale(1.2);
  }

  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.animate-slide-in-right {
  animation: slide-in-right 800ms ease-in-out forwards;
  opacity: 1 !important;

  /* 动画开始时覆盖初始透明度 */
}

.animate-fade-in {
  animation: fade-in 800ms ease-in-out forwards;
  opacity: 1 !important;
}

.animation-delay-200.animate-slide-in-right {
  animation-delay: 200ms;
}

.animation-delay-200.animate-fade-in {
  animation-delay: 200ms;
}

/* Swiper 样式 */
.honors-swiper {
  width: 106rem;
  padding-bottom: 48px;
}

.honors-swiper :deep(.swiper-pagination) {
  bottom: 0;
}

.honors-swiper :deep(.swiper-pagination-bullet) {
  width: 0.5rem;
  height: 0.5rem;
  background: rgb(var(--v-theme-primary));
  opacity: 0.3;
}

.honors-swiper :deep(.swiper-pagination-bullet-active) {
  width: 1.5rem;
  border-radius: 0.25rem;
  opacity: 1;
}

/* 荣誉卡片样式 */
.honor-card {
  position: relative;
  width: 21rem;
  height: 24.69rem;
  background: #fff;
  box-shadow: 0 0.25rem 0.25rem 0 rgba(186, 194, 202, 30%);

  &::before {
    position: absolute;
    z-index: 0;
    top: 1rem;
    left: 1rem;
    width: 19.16rem;
    height: 18.05rem;
    background: #f2f4f6;
    content: "";
  }
}

.honor-card-image-box {
  cursor: pointer;
  transform-origin: center center;
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);

  .honor-card-image {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 14.45rem;
    max-height: 15rem;
    box-shadow: 0 1.25rem 1.88rem 0 rgba(200, 189, 52, 8%);

    /* 不用 transform 居中，用 margin */
    transform: none;
    translate: -50% -50%;

    /* 新语法替代 translate(-50%, -50%) */
  }
}

.honor-card-image-box-mobile {
  display: flex;
  width: 100%;
  min-height: 2rem;
  flex-direction: row;
  align-items: center;
  background-color: rgba(186, 194, 202, 30%);
  cursor: pointer;
  transform-origin: center center;
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);

  .honor-card-image-mobile {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 1.25rem 1.88rem 0 rgba(200, 189, 52, 8%);

    /* 新语法替代 translate(-50%, -50%) */
  }
}

.honor-card-content {
  position: relative;
  z-index: 0;
}

.honor-card-content::before {
  position: absolute;

  /* 透明度 20% */
  z-index: -1;
  background-image: url("@base/assets/images/about-us/back1.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  content: "";
  inset: 0;
  opacity: 0.2;

  /* 在内容下方 */
}

@keyframes fade-zoom {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(0.625rem);
  }

  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.animate-fade-zoom {
  animation: fade-zoom 0.5s ease-out forwards;
}
</style>
